export default __webpack_public_path__ + "static/media/Iubat-logo.7fd29c03.png";